(function () {
  'use strict';

  function withPartnerParameters(value) {
    try {
      var url = new URL(value, window.location.origin);
      url.searchParams.set('embed', 'laforte');
      url.searchParams.set('utm_source', 'la-forte');
      url.searchParams.set('utm_medium', 'storefront_embed');
      url.searchParams.set('utm_campaign', 'zuuvo_launcher');
      return url.toString();
    } catch (error) {
      return 'https://zuuvo.co.in/dashboard?embed=laforte&utm_source=la-forte&utm_medium=storefront_embed&utm_campaign=zuuvo_launcher';
    }
  }

  function boot(root) {
    if (!root || root.dataset.zuuvoReady === 'true') return;
    root.dataset.zuuvoReady = 'true';

    var modal = root.querySelector('[data-zuuvo-modal]');
    var frame = root.querySelector('[data-zuuvo-frame]');
    var loader = root.querySelector('[data-zuuvo-loader]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-zuuvo-open]'));
    var closer = root.querySelector('[data-zuuvo-close]');
    var external = root.querySelector('[data-zuuvo-external]');
    var appUrl = withPartnerParameters(root.dataset.zuuvoUrl || 'https://zuuvo.co.in/dashboard');
    var lastFocused = null;
    var loaded = false;
    var historyArmed = false;

    if (!modal || !frame || !closer || !openers.length) return;
    if (external) external.href = appUrl;

    function focusableElements() {
      return Array.prototype.slice.call(modal.querySelectorAll('a[href], button:not([disabled]), iframe'));
    }

    function setOpenState(isOpen) {
      if (isOpen) {
        modal.hidden = false;
        if (typeof modal.showModal === 'function' && !modal.open) modal.showModal();
      } else {
        if (typeof modal.close === 'function' && modal.open) modal.close();
        modal.hidden = true;
      }
      modal.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      document.body.classList.toggle('lfz-modal-open', isOpen);
      root.dataset.zuuvoOpen = isOpen ? 'true' : 'false';
    }

    function openZuuvo(event) {
      if (event) event.preventDefault();
      if (!modal.hidden) return;
      lastFocused = document.activeElement;
      setOpenState(true);

      if (!loaded) {
        loader.hidden = false;
        frame.src = appUrl;
        loaded = true;
      }

      if (!historyArmed) {
        window.history.pushState({ lfZuuvoOverlay: root.dataset.sectionId || true }, '', window.location.href);
        historyArmed = true;
      }

      window.requestAnimationFrame(function () { closer.focus(); });
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'zuuvo_embed_open', partner: 'la-forte' });
      }
    }

    function finishClose() {
      setOpenState(false);
      historyArmed = false;
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: 'zuuvo_embed_close', partner: 'la-forte' });
      }
    }

    function closeZuuvo(fromHistory) {
      if (modal.hidden) return;
      var shouldRewindHistory = historyArmed && !fromHistory;
      finishClose();
      if (shouldRewindHistory) window.history.back();
    }

    openers.forEach(function (opener) { opener.addEventListener('click', openZuuvo); });
    closer.addEventListener('click', function () { closeZuuvo(false); });
    modal.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeZuuvo(false);
    });

    frame.addEventListener('load', function () {
      if (frame.src && frame.src !== 'about:blank') loader.hidden = true;
    });

    window.addEventListener('popstate', function () {
      if (!modal.hidden) closeZuuvo(true);
    });

    window.addEventListener('message', function (event) {
      if (event.origin !== 'https://zuuvo.co.in') return;
      if (event.data && event.data.type === 'zuuvo:close') closeZuuvo(false);
    });

    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeZuuvo(false);
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bootAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-zuuvo-root]'), boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(document); });
  } else {
    bootAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { bootAll(event.target); });
})();
